import jwt from 'jsonwebtoken';
import Storage from './storage';
import axios from 'axios';

export default class Token {

  constructor() {
    this.auth = [];
    this.storage = new Storage('bootstrap');
    const tokenFromHash = this.getTokenFromHash(window.location.hash);
    const id_tokenFromHash = this.getIdTokenFromHash(window.location.hash);
    if (tokenFromHash) {
      this.tokenHandler(tokenFromHash, id_tokenFromHash);
    }
  }

  tokenHandler(token, id_token) {
    const decoded = jwt.decode(token);
    const currentUser = {
      fullName: decoded.name,
      name: decoded.given_name,
      surname: decoded.family_name,
      username: decoded.username,
      preferred_username: decoded.preferred_username,
      email: decoded.email
    };
    window.localStorage.setItem('token', token);
    window.localStorage.setItem('id_token', id_token);
    this.storage.setItem('currentUser', currentUser);
    window.history.replaceState(
      {},
      document.title,
      `${window.location.protocol}//${window.location.host}/${window.location.pathname}`
    );
  }

  getTokenFromHash(hash) {
    return new URLSearchParams(hash).get('access_token');
  }

  getIdTokenFromHash(hash) {
    return new URLSearchParams(hash).get('id_token');
  }

  getToken() {
    return window.localStorage.getItem('token');
  }

  getTokenInfo() {
    return jwt.decode(window.localStorage.getItem('token'));
  }

  resetToken() {
    return window.localStorage.setItem('token', '');
  }

  isValidToken() {
    let currentTime = Math.floor(Date.now() / 1000);
    /*let ts = new Date(currentTime*1000);
    console.log(ts.toString());
    let expire = new Date(jwt.decode(this.getToken()).exp*1000);
    console.log(expire.toString());
    console.log (jwt.decode(this.getToken()).exp>=currentTime);*/
    return (jwt.decode(this.getToken()).exp >= currentTime);
  }

  async getManuals(onResult) {
    const options = {
      method: 'get',
      //url: `http://${window.location.hostname}:${window.location.port}/api/configurazioni/v1/configurazioni/manuali`,
      hostname: window.location.hostname,
      port: window.location.port,
      url: `/api/configurazioni/v1/configurazioni/manuali`,
      headers: {
        'Authorization': `Bearer ${this.getToken()}`,
        'Content-Type': 'application/json'
      }
    };
    return this._getAuthorization(options, onResult);
  }

  async getAuth(onResult) {
    const options = {
      method: 'get',
      //url: `http://${window.location.hostname}:${window.location.port}/api/authservice/clients/${this.getTokenInfo().azp}/menus/`,
      hostname: window.location.hostname,
      port: window.location.port,
      url: `/api/authservice/clients/${this.getTokenInfo().azp}/menus/`,
      headers: {
        'Authorization': `Bearer ${this.getToken()}`,
        'Content-Type': 'application/json'
      }
    };
    return this._getAuthorization(options, onResult);
  }

  async getAuthFE(onResult) {
    const options = {
      method: 'get',
      hostname: window.location.hostname,
      port: window.location.port,
      url: `/api/authservice/v2/authFE/user/${this.getTokenInfo().username}`,
      //url: `http://${window.location.hostname}:${window.location.port}/api/authservice/v2/authFE/user/${this.getTokenInfo().username}`,
      headers: {
        'Authorization': `Bearer ${this.getToken()}`,
        'Content-Type': 'application/json'
      }
    };
    return this._getAuthorization(options, onResult);
  }

  async _getAuthorization(options, onResult) {
    try {
      console.log(options)
      let response = await axios(options);
      if (response.status !== 200) {
        console.error('Errore di autorizzazione !', response.status, response.data, response);
        return {};
      } else {
        return response.data
      }
    } catch {
      console.log("GET request error");
      return {};
    };
  }
}
